"use client";

import Link from "next/link";
import { useLocale } from "@/lib/i18n/locale-context";
import { localizeHref } from "@/lib/i18n/routing";
import { cn } from "@/lib/utils";

type LogoProps = {
  className?: string;
  priority?: boolean;
};

export default function Logo({ className }: LogoProps) {
  const locale = useLocale();

  return (
    <Link
      href={localizeHref("/", locale)}
      title="Greip - Home"
      className={cn(
        "inline-flex shrink-0 items-center rounded-xl text-foreground transition-opacity duration-150 ease-[var(--ease-out)] hover:opacity-90",
        className,
      )}
    >
      <span className="sr-only">Greip</span>
      <svg
        width={32}
        height={32}
        viewBox="-2 -5 73 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="block h-8 w-8"
        aria-hidden
      >
        <path
          d="M56.7727 57.5579L51.031 63.3822V34.6061H51.0279C51.0279 34.5395 51.031 34.4682 51.031 34.4017C51.031 24.9427 43.4697 17.2741 34.1434 17.2741C24.8155 17.2741 17.2558 24.9443 17.2558 34.4017C17.2558 41.8484 21.94 48.1845 28.4829 50.5453V38.0981C29.4873 40.123 31.6302 41.5236 34.1137 41.5236C36.5972 41.5236 38.7386 40.123 39.7445 38.0981V50.5659C39.7554 50.5627 39.7648 50.5595 39.7726 50.5548V72.8364C39.7726 74.096 39.279 75.3017 38.4028 76.1922C37.8842 76.7182 37.2969 77.1302 36.6675 77.4264C36.1427 77.6736 35.5897 77.8431 35.0259 77.9303C34.915 77.9445 34.8025 77.962 34.6916 77.9731C34.5948 77.9794 34.5011 77.9873 34.4027 77.9937C34.309 77.9968 34.2121 78 34.1137 78C34.0653 78 34.02 77.9968 33.9716 77.9937C32.4518 77.9683 30.9352 77.3726 29.7731 76.1985L11.3985 57.5579C-1.13285 44.8509 -1.13285 24.244 11.3985 11.5338C23.9252 -1.17794 44.2428 -1.17794 56.7742 11.5338C69.3009 24.244 69.3009 44.8509 56.7727 57.5579Z"
          fill="currentColor"
        />
        <path
          d="M38.8261 34.5728C38.8261 37.2156 36.7143 39.3561 34.109 39.3561C31.5037 39.3561 29.392 37.214 29.392 34.5728C29.392 31.93 31.5037 29.7894 34.109 29.7894C36.7143 29.7878 38.8261 31.93 38.8261 34.5728Z"
          fill="currentColor"
        />
      </svg>
    </Link>
  );
}
